<template>
  <TransitionRoot as="template" :show="isOpen">
    <Dialog as="div" class="relative z-[999]" @close="onClose">
      <div
        class="fixed top-[calc(var(--header-height)+var(--discount-compaign-visible-height))] inset-0 overflow-hidden"
      >
        <div class="absolute inset-0 overflow-hidden">
          <div
            class="pointer-events-none fixed top-[calc(var(--header-height)+var(--discount-compaign-visible-height))] inset-y-0 left flex max-w-full"
          >
            <TransitionChild
              as="template"
              enter="transform transition ease-in-out duration-250"
              enter-from="-translate-x-full"
              enter-to="translate-x-0"
              leave="transform transition ease-in-out duration-250"
              leave-from="translate-x-0"
              leave-to="-translate-x-full"
              @after-enter="onAfterEnter"
            >
              <DialogPanel
                class="pointer-events-auto relative w-screen max-w-[493px]"
              >
                <div class="flex h-full flex-col overflow-auto bg-white">
                  <div
                    class="flex items-center sticky top-0 bg-white z-1 border-b border-gray-60 py-5 px-4 md:px-18"
                  >
                    <UiButton
                      variant="clear"
                      class="h-auto p-0 border-0 md:border border-gray-60 md:h-9.5 md:px-2.5 uppercase text-xs"
                      content-class="flex items-center gap-x-1.5"
                      @click="onClose"
                    >
                      <span class="hidden md:inline-block">
                        {{ $t("closeFilters") }} {{ appliedFiltersCount }}
                      </span>
                      <UiIcon name="close" class="size-6 shrink-0" />
                    </UiButton>
                    <span class="uppercase md:hidden text-xs ml-3.5">
                      {{ $t("filters") }}
                    </span>
                    <p
                      class="uppercase ml-auto text-xs md:font-bold order-1 md:order-3"
                    >
                      {{ $t("amountProducts", { count: productsCount }) }}
                    </p>
                  </div>
                  <slot />
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup lang="ts">
import {
  Dialog,
  DialogPanel,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";

const props = defineProps<{
  modelValue: boolean;
  appliedFiltersCount: string;
  productsCount: number;
}>();

const emit = defineEmits(["update:modelValue"]);

const generalInternalStore = useGeneralInternalStore();

const isOpen = computed<boolean>({
  set(val) {
    emit("update:modelValue", val);
  },
  get() {
    return props.modelValue;
  },
});

watch(
  () => props.modelValue,
  (val) => {
    generalInternalStore.systemOverlay = val;
  },
);

function onAfterEnter() {
  setTimeout(() => {
    const inertEl = document.querySelector("[inert]");
    if (inertEl) {
      inertEl.removeAttribute("inert");
    }
  }, 0);
}

function onClose() {
  generalInternalStore.systemOverlay = false;
  isOpen.value = false;
}

onBeforeUnmount(() => {
  onClose();
});
</script>
